<template>
<div>
  <top-header></top-header>
  <section class="main-content">
    <router-view></router-view>
  </section>

  <bottom-footer></bottom-footer>
</div>
</template>

<script>
import topHeader from "./topHeader";
import bottomFooter from "@/Layout/bottomFooter";
export default {
  name: "Layout",
  components:{
    topHeader,
    bottomFooter
  }
}
</script>

<style scoped lang="scss">
.main-content{
  padding-top: 72px;
  min-height: calc(100vh - 102px);
  padding-bottom: 80px;
}
</style>
